import { getApiErrorMessage } from '../../utils/apiError';

/** Single home for stable settlement-domain code -> Polish operator message. */
export const ORDER_SETTLEMENT_ERROR_KEYS: Record<string, string> = {
  SETTLEMENT_ACCESS_DENIED: 'orders:orderDetail.settlementErrors.accessDenied',
  SETTLEMENT_FINANCE_ACCESS_DENIED: 'orders:orderDetail.settlementErrors.financeAccessDenied',
  SETTLEMENT_FINAL_ACCESS_DENIED: 'orders:orderDetail.settlementErrors.finalAccessDenied',
  SETTLEMENT_QUOTE_NOT_ALLOWED: 'orders:orderDetail.settlementErrors.quoteNotAllowed',
  SETTLEMENT_STATUS_NOT_ALLOWED: 'orders:orderDetail.settlementErrors.statusNotAllowed',
  SETTLEMENT_FINAL_STATUS_NOT_ALLOWED: 'orders:orderDetail.settlementErrors.finalStatusNotAllowed',
  SETTLEMENT_FINAL_STATUS_CONFIRMATION_REQUIRED: 'orders:orderDetail.settlementErrors.finalStatusConfirmationRequired',
  SETTLEMENT_FINAL_DELIVERY_INCOMPLETE: 'orders:orderDetail.settlementErrors.finalDeliveryIncomplete',
  SETTLEMENT_INCOMPLETE_REASON_REQUIRED: 'orders:orderDetail.settlementErrors.incompleteReasonRequired',
  SETTLEMENT_FINANCIAL_BASIS_INCOMPLETE: 'orders:orderDetail.settlementErrors.financialBasisIncomplete',
  SUPPLIER_ALLOCATION_COVERAGE_CONFLICT: 'orders:orderDetail.settlementErrors.supplierAllocationCoverageConflict',
  SETTLEMENT_COMMAND_ADMIN_REQUIRED: 'orders:orderDetail.settlementErrors.adminDecisionRequired',
  SETTLEMENT_ALREADY_FINAL: 'orders:orderDetail.settlementErrors.alreadyFinal',
  SETTLEMENT_NO_DELIVERED_TRANSPORT: 'orders:orderDetail.settlementErrors.noDeliveredTransport',
  SETTLEMENT_OPERATIONAL_INCOMPLETE_CARGO: 'orders:orderDetail.settlementErrors.incompleteCargo',
  SETTLEMENT_OPERATIONAL_MIXED_CURRENCY: 'orders:orderDetail.settlementErrors.mixedCurrency',
  SETTLEMENT_OPERATIONAL_REQUIRES_CORRECTION: 'orders:orderDetail.settlementErrors.requiresCorrection',
  SETTLEMENT_NO_PROGRESS: 'orders:orderDetail.settlementErrors.noProgress',
  SETTLEMENT_EXCEEDS_CURRENT: 'orders:orderDetail.settlementErrors.exceedsCurrent',
  SETTLEMENT_NEGATIVE_TOTAL: 'orders:orderDetail.settlementErrors.negativeTotal',
  SETTLEMENT_INVALID_CORRECTION_TARGET: 'orders:orderDetail.settlementErrors.invalidCorrectionTarget',
  SETTLEMENT_NOTE_REQUIRED: 'orders:orderDetail.settlementErrors.noteRequired',
  SETTLEMENT_INVALID_DATE: 'orders:orderDetail.settlementErrors.invalidDate',
  SETTLEMENT_INVALID_AMOUNT: 'orders:orderDetail.settlementErrors.invalidAmount',
  SETTLEMENT_FINANCIAL_LIMIT_EXCEEDED: 'orders:orderDetail.settlementErrors.financialLimitExceeded',
  SETTLEMENT_OPERATIONAL_INPUT_FORBIDDEN: 'orders:orderDetail.settlementErrors.operationalInputForbidden',
  SETTLEMENT_OPERATIONAL_MODE_REQUIRED: 'orders:orderDetail.settlementErrors.operationalModeRequired',
  SETTLEMENT_INVALID_KIND: 'orders:orderDetail.settlementErrors.invalidKind',
};

export function getOrderSettlementErrorMessage(
  error: any,
  t: any,
  fallbackKey: string,
  fallbackParams?: Record<string, unknown>,
): string {
  return getApiErrorMessage(error, t, fallbackKey, ORDER_SETTLEMENT_ERROR_KEYS, fallbackParams);
}
